export const floatingIndexList = [
  { name: "None", label: "", value: "" },
  { name: "1-Month LIBOR/Term SOFR", label: "1-Month LIBOR/Term SOFR", value: "a11d7bd4-4681-11e9-82f6-0242ac120002" },
  { name: "3-Month LIBOR/Term SOFR", label: "3-Month LIBOR/Term SOFR", value: "b46abe9a-4681-11e9-82f6-0242ac120002" },
  { name: "6-Month LIBOR/Term SOFR", label: "6-Month LIBOR/Term SOFR", value: "bca352c6-4681-11e9-82f6-0242ac120002" },
  { name: "Term SOFR", label: "Term SOFR", value: "c6b1a7bb-4681-11e9-82f6-0242ac120002" },
  { name: "30 Day Avg SOFR", label: "30 Day Avg SOFR", value: "d48732b4-6011-4ef5-8098-98691f75e7ec" },
  { name: "Overnight SOFR", label: "Overnight SOFR", value: "d3d84f25-4681-11e9-82f6-0242ac120002" },
  { name: "Fed Funds", label: "Fed Funds", value: "ea5cd592-4681-11e9-82f6-0242ac120002" },
  { name: "SIFMA", label: "SIFMA", value: "f2598911-4681-11e9-82f6-0242ac120002" },
  { name: "Prime", label: "Prime", value: "ddab792e-4681-11e9-82f6-0242ac120002" }
];

export default {
  ONE_MONTH_LIBOR: "a11d7bd4-4681-11e9-82f6-0242ac120002",
  THREE_MONTH_LIBOR: "b46abe9a-4681-11e9-82f6-0242ac120002",
  SIX_MONTH_LIBOR: "bca352c6-4681-11e9-82f6-0242ac120002",
  TWELVE_MONTH_LIBOR: "c6b1a7bb-4681-11e9-82f6-0242ac120002",
  THIRTY_DAY_AVG_SOFR: "d48732b4-6011-4ef5-8098-98691f75e7ec",
  SOFR: "d3d84f25-4681-11e9-82f6-0242ac120002",
  FED_FUNDS: "ea5cd592-4681-11e9-82f6-0242ac120002",
  SIFMA: "f2598911-4681-11e9-82f6-0242ac120002",
  PRIME: "ddab792e-4681-11e9-82f6-0242ac120002"
};
